import { Link as LINK } from "@/types/global";
import { getValidUrl } from "@/utils/helper/string";
import React from "react";
import { Link } from "react-router-dom";

interface CustomLinkProps {
  link: LINK;
  isExternal?: boolean;
  className?: string;
  disabled?: boolean;
  variant?: "default" | "header";
}

const CustomLink: React.FC<CustomLinkProps> = ({ link, isExternal = false, className, variant = "default", disabled = false }) => {
  const baseClasses = "text-text-link hover:underline px-1";
  const headerClasses =
    "flex justify-center hover:text-white hover:bg-brand-secondary items-center py-1 md:py-1.5 px-3 md:px-4 rounded border border-text-primary bg-brand-light text-brand-primary text-13 !leading-5 transition-all duration-500 active:bg-brand-dark active:ring-brand-shade active:ring-offset-1 active:text-white ";

  const linkClasses = variant === "header" ? headerClasses : baseClasses;

  if (disabled) {
    return <span className={`${linkClasses} ${className} opacity-50 cursor-not-allowed`}>{link.text}</span>;
  }

  if (isExternal) {
    return (
      <a href={getValidUrl(link.value)} className={`${linkClasses} ${className}`} target="_blank" rel="noopener noreferrer">
        {link.text}
      </a>
    );
  }

  return (
    <Link to={link.value} className={`${linkClasses} ${className}`}>
      {link.text}
    </Link>
  );
};

export default CustomLink;
